export const SUPPORTED_LOCALES = ["en", "ru", "es", "de", "fa"] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: SupportedLocale = "en";

export function isSupportedLocale(value: string | null | undefined): value is SupportedLocale {
  if (!value) return false;
  const normalized = value.toLowerCase().split("-")[0];
  return SUPPORTED_LOCALES.includes(normalized as SupportedLocale);
}

export function normalizeLocale(value: string | null | undefined, fallback: SupportedLocale = DEFAULT_LOCALE): SupportedLocale {
  if (!value) return fallback;
  const normalized = value.toLowerCase().split("-")[0];
  return isSupportedLocale(normalized) ? normalized : fallback;
}
